import { createAction, props } from '@ngrx/store';

export const saveDifferentLocations = createAction(
    '[AUTH] save differentLocations',
    props<{ value: any }>(),
);
